'use strict';

module.exports = /* @ngInject */ function($scope, $interval, authService) {

	// init current refresh Rate
	$scope.refreshRate = authService.refreshInterval();
	let refreshTokenInterval;


	// get new access_token from auth.service
	const getNewToken = function() {
		authService.token.renew().$promise.then(
			function(data) {
				// if access_token is undefined, an error occured: force logout
				if(typeof data.access_token === 'undefined') {
					console.error(data.error);
					logout();
				} else {
					// got new token, update config
					authService.updateAccessToken(data);

					// init new refreshInterval Rate
					$scope.refreshRate = authService.refreshInterval();	
				}				
			},
			function(err) {
				console.error(err);
			}
		);
	};
	
	// start local interval by variable
	const startInterval = function() {
		refreshTokenInterval = $interval(getNewToken, $scope.refreshRate);
	};

	// watch refreshRate, if modified, cancel current interval an start new interval with new refreshRate
	$scope.$watch("refreshRate", function(){
		$interval.cancel(refreshTokenInterval);
		startInterval();
	});

	// init startInterval
	startInterval();
};
